import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";

const UserRolesTable = ({ data, onDelete }) => {
  const columns = [
    {
      accessorKey: "code",
      header: "Código",
    },
    {
      accessorKey: "name",
      header: "Nombre",
    },
    {
      accessorKey: "description",
      header: "Descripción",
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <TableDeleteButton onClickHandler={() => onDelete(data.id)} />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default UserRolesTable;
